module.exports = __webpack_public_path__ + "media/cortina/guia-izq-entreparedes-15a9721c.png";